
export default {
  methods: {
    async enviarBoleto (id_pedido, email, vendedor, reenvio = false) {
      return this.$http.post('/proposta/boleto/enviar', { id_pedido: id_pedido, email, vendedor: vendedor, reenvio })
    },
    enviarBoletosEmlote (propostas) {
      const ids = propostas.map(proposta => proposta.id_pedido)
      const id_carrinho = propostas[0].id_carrinho
      return this.$http.post('/carrinho/boletos_em_lote', { idsPedidos: ids, id_carrinho })
    },
    enviarPagamentosMultiplos (propostas) {
      const ids = propostas.map(proposta => proposta.id_pedido)
      const id_carrinho = propostas[0].id_carrinho
      return this.$http.post('/carrinho/pagamentos_multiplos', { idsPedidos: ids, id_carrinho })
    }
  }
}
